import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

import { HomeTriageCardGrid } from "./home-triage-card-grid"

/**
 * OKS-706 — Loading skeleton for the {@link HomeTriageSection} shell.
 *
 * A card-grid skeleton matching the populated layout (embed block + two
 * text lines + action-row placeholders), NOT a spinner (UX Spec §3
 * Loading). Shown while the deferred section prop is pending on first
 * paint and during the Retry round-trip, so there's no layout shift when
 * the cards arrive.
 *
 * @param count - number of skeleton cards to render (default 3, matching
 *   a filled desktop row).
 */
interface HomeTriageSkeletonProps {
  count?: number
}

export function HomeTriageSkeleton({ count = 3 }: HomeTriageSkeletonProps) {
  return (
    <HomeTriageCardGrid data-testid="home-triage-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} aria-hidden="true">
          <CardContent className="flex flex-col gap-3 pt-6">
            {/* Embed block */}
            <Skeleton className="mx-auto min-h-[180px] w-full max-w-[420px] rounded-xl" />
            {/* Identity + facts lines */}
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-3 w-1/2" />
            {/* Action row */}
            <div className="mt-1 flex gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-24" />
            </div>
          </CardContent>
        </Card>
      ))}
    </HomeTriageCardGrid>
  )
}
